<template>
<div class="chapter">
<div class="inner_page">
<section epub:type="toc" id="_idContainer002" role="doc-toc">
<p class="TOCtitle">Table of Contents</p>
<p class="TOCitem"><a href="#/Seeking_the_Truth#_idTextAnchor001">Seeking the Truth</a> by Terri Reed</p>
<p class="TOCitem"><span href="#/Trail_of_Danger#_idTextAnchor018" title="Link target outside of Sample">Trail of Danger</span> by Valerie Hansen</p>
<p class="TOCitem">Excerpt from <a href="#/Excerptone#_idTextAnchor040">True Blue K-9 Unit: Brooklyn Christmas</a> by Laura Scott</p>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Table_of_Contents.vue?5952a062